import { action, get } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Group } from "@shared/models/group"
import FindDoc from "cc-frontend/helpers/find-doc"
import LiveQueryResource from "cc-frontend/helpers/live-query"
import type ModalManager from "cc-frontend/services/modal-manager"
import { isGroupMembershipIndividual } from "cc-frontend/utils/group"
import { use } from "ember-could-get-used-to-this"
import { filter } from "lodash-es"

interface Signature {
  Element: any
  Args: {
    groupId: string
    parentGroup: Group
    currentSchoolYearId: string
  }
}

export default class GroupTeam extends Component<Signature> {
  @service declare modalManager: ModalManager

  @use group = new FindDoc(() => ["group", this.args.groupId])
  @use planbooksQuery = new LiveQueryResource(() => {
    let queryId = this.args.groupId + ":" + this.args.currentSchoolYearId
    return ["planbooks_for_groups_and_school_year", queryId]
  })

  get teamMembers() {
    if (this.group.content === null) return []
    return filter(get(this.group.content.attributes, "memberships"), isGroupMembershipIndividual)
  }

  @action
  manageTeam(groupId) {
    this.modalManager.openModal("group/create-team", {
      groupId: groupId,
      parentGroup: this.args.parentGroup,
      currentSchoolYearId: this.args.currentSchoolYearId,
    })
  }

  @action
  addMembers(group) {
    this.modalManager.openModal("group/add-members", {
      group: group,
      makeAdmin: false,
      initiallyOpened: true,
    })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::Team": typeof GroupTeam
  }
}
